<template>
  <section class="ds s-py-45 s-py-xl-75 c-gutter-60">
    <div class="container">
      <div class="row">
        <main class="col-lg-12">
          <article>
            <div class="entry-content">
              <div class="woocommerce">
                <div class="woocommerce-MyAccount-content">
                  <form id="child-form" role="form" style="display: block">
                    <p class="mm-font">
                      အောက်ပါပေးထားသော Form အချက်အလက်များကို ဖြည့်ပေးပါ
                    </p>
                    <label class="form-group">
                      <label class="mm-font">အမည်</label>
                      <input
                        type="text"
                        class="form-control"
                        name="name"
                        v-model="clairvoyance.name"
                        required
                      />
                      <span
                        class="error__message"
                        v-if="!clairvoyance.name && errors.name"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ errors.name }}
                      </span>
                    </label>
                    <label class="form-group">
                      <label class="mm-font">မွေးသက္ကရာဇ်</label>
                      <md-datepicker
                        :md-disabled-dates="disablePastDates"
                        value-format="YYYY-MM-DD"
                        class="input-container"
                        v-model="clairvoyance.birth_date"
                        ref="datepicker"
                      >
                        <label
                          class="date__picker"
                          v-if="!clairvoyance.birth_date"
                          >YYYY-MM-DD</label
                        >
                      </md-datepicker>
                      <div
                        class="error__message"
                        v-if="!clairvoyance.birth_date && errors.birth_date"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ errors.birth_date }}
                      </div>
                    </label>
                    <label class="form-group">
                      <label class="mm-font">နေ့နံ</label>
                      <div class="dropdown__container">
                        <select
                          class="mm-font __mm"
                          name="nyih_nan"
                          v-model="clairvoyance.nyih_nan"
                          required
                        >
                          <option value="" class="__mm" selected>
                            နေ့နံရွေးချယ်ပါ
                          </option>
                          <option value="တနင်္ဂနွေ" class="__mm">
                            တနင်္ဂနွေ
                          </option>
                          <option value="တနင်္လာ" class="__mm">တနင်္လာ</option>
                          <option value="အင်္ဂါ" class="__mm">အင်္ဂါ</option>
                          <option value="ဗုဒ္ဓဟူး" class="__mm">
                            ဗုဒ္ဓဟူး
                          </option>
                          <option value="ရာဟု" class="__mm">ရာဟု</option>

                          <option value="ကြာသပတေး" class="__mm">
                            ကြာသပတေး
                          </option>
                          <option value="သောကြာ" class="__mm">သောကြာ</option>
                          <option value="စနေ" class="__mm">စနေ</option>
                        </select>
                        <i class="pi pi-chevron-down dropdown__icon"></i>
                      </div>
                      <span
                        class="error__message"
                        v-if="!clairvoyance.nyih_nan && errors.nyih_nan"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ errors.nyih_nan }}
                      </span>
                    </label>
                    <input
                      type="radio"
                      name="marital_status"
                      value="Yes"
                      v-model="clairvoyance.marital_status"
                      required
                    />
                    <span for="" class="mm-font"> အိမ်ထောင်ရှိ </span>
                    <input
                      type="radio"
                      name="marital_status"
                      value="No"
                      v-model="clairvoyance.marital_status"
                      required
                    />
                    <span for="" class="mm-font"> အိမ်ထောင်မရှိ </span>
                    <div
                      class="error__message ml-1"
                      v-if="
                        !clairvoyance.marital_status && errors.marital_status
                      "
                    >
                      <i class="pi pi-exclamation-circle mr-1"></i>
                      {{ errors.marital_status }}
                    </div>
                    <br />
                    <br />
                    <br />
                    <label class="form-group">
                      <label for="" class="mm-font">အလုပ်အကိုင်</label>
                      <div
                        style="
                          display: grid;
                          grid-template-rows: 1fr 1fr;
                          gap: 5px;
                        "
                      >
                        <div class="dropdown__container">
                          <select
                            name="job"
                            class="mm-font __mm"
                            v-model="clairvoyance.job"
                            required
                          >
                            <option value="" selected hidden>
                              အလုပ်အကိုင် အမျိုးအစား
                            </option>
                            <option value="အစိုးရဝန်ထမ်း">အစိုးရဝန်ထမ်း</option>
                            <option value="ကုမ္ပဏီဝန်ထမ်း">
                              ကုမ္ပဏီဝန်ထမ်း
                            </option>
                            <option value="ကိုယ်ပိုင်စီးပွားရေး">
                              ကိုယ်ပိုင်စီးပွားရေး
                            </option>
                            <option value="ကျောင်းသား/သူ">ကျောင်းသား/သူ</option>
                            <option value="အခြား">အခြား</option>
                          </select>
                          <i class="pi pi-chevron-down dropdown__icon"></i>
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          name="job_detail"
                          v-model="clairvoyance.job_detail"
                          placeholder="အလုပ်ကိုင်အသေးစိတ်"
                        />
                        <div
                          class="error__message"
                          v-if="
                            (!clairvoyance.job || !clairvoyance.job_detail) &&
                            errors.job
                          "
                        >
                          <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                          {{ errors.job }}
                        </div>
                      </div>
                    </label>
                    <input
                      type="radio"
                      name="gender"
                      value="Male"
                      v-model="clairvoyance.gender"
                      required
                    />
                    <span for="" class="mm-font">ကျား</span>
                    <input
                      type="radio"
                      name="gender"
                      value="Female"
                      required
                      v-model="clairvoyance.gender"
                    />
                    <span for="" class="mm-font"> မ </span>
                    <div
                      class="error__message ml-1"
                      v-if="!clairvoyance.gender && errors.gender"
                    >
                      <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                      {{ errors.gender }}
                    </div>
                    <br />
                    <br />
                    <div class="form-group">
                      <span class="mm-font" __mm>ဗေဒင်ဆရာ</span>
                      <div class="fixed_sayar_display mm-font __mm">
                        {{ clairvoyance.baydin_sayar }}
                      </div>
                      <input
                        type="hidden"
                        name="baydin_sayar"
                        v-model="clairvoyance.baydin_sayar"
                      />
                    </div>
                    <br />
                    <p class="mm-font">မေးမြန်းလိုသည့်အကြာင်းအရာကိုရေးပါ။</p>
                    <label class="form-group">
                      <textarea
                        name="about"
                        v-model="clairvoyance.about"
                        class="mm-font test"
                        rows="10"
                        cols="35"
                        placeholder=""
                        style="color: black"
                        required
                      ></textarea>
                      <div
                        class="error__message"
                        v-if="!clairvoyance.about && errors.about"
                      >
                        <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                        {{ errors.about }}
                      </div>
                    </label>
                    <label class="form-group">
                      <label for="" class="mm-font __mm">
                        Viber အသုံးပြုသော ဖုန်းနံပါတ်အားထည့်ပါ
                        (မှန်ကန်စွာဖြည့်ပေးပါရန်)
                      </label>
                      <input
                        type="number"
                        class="form-control"
                        name="phone_number"
                        v-model="clairvoyance.phone_number"
                        placeholder="09xxxxxxxxx"
                        @input="validateForm"
                        required
                      />
                      <div
                        class="error__message error__phoneNo"
                        v-if="errors.phone_number"
                      >
                        <i class="pi pi-exclamation-circle mr-1"></i>
                        {{ errors.phone_number }}
                      </div>
                    </label>
                    <div>
                      <p class="mm-font __mm face_upload_title">
                        အကြားအမြင်အတွက် မျက်နှာ ၁ပုံထည့်ပေးပါရန်
                      </p>
                      <div class="face_upload_grid">
                        <div class="face_upload_item">
                          <div class="mm-font __mm face_upload_label">
                            မျက်နှာပုံ
                          </div>
                          <label class="face_upload_btn mm-font __mm" @click="onFaceImageClick">
                            {{ face_image ? "ပြောင်းရန်" : "ပုံရွေးရန်" }}
                          </label>
                          <img
                            v-if="face_image_preview"
                            :src="face_image_preview"
                            class="face_upload_preview"
                            alt="face_image"
                          />
                          <div
                            class="error__message"
                            v-if="errors.face_image"
                          >
                            <i class="pi pi-exclamation-circle mr-1 mb-1"></i>
                            {{ errors.face_image }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="t_c_agreement">
                      By continuing, you agree to
                      <span @click.prevent="redirectTNC()"
                        >Terms and Conditions.</span
                      >
                    </p>
                    <br />
                    <!-- <div>ဉာဏ်ပူဇော်ခ 
                      <del>၁၈၀၀၀</del>
                      ၁၅၃၀၀ ကျပ် ဖြစ်ပါသည်။
                    </div> -->
                    <div>ငွေပေးချေပြီးပါက ဟောစာတမ်းအား (၃) ရက်အတွင်း 'အဖြေများ' စာမျက်နှာတွင် ဝင်ရောက် ကြည့်ရှုနိုင်ပါသည်။</div>
                    <p>
                      <input
                        type="submit"
                        @click.prevent="paymentProvider()"
                        :disabled="disabled"
                        class="woocommerce-Button button mm-font __mm"
                        name="save_account_details"
                        value="အတည်ပြုမည်"
                      />
                    </p>
                  </form>
                  <br />
                  <!-- <div>
                    <div class="col-md-12">
                      <p class="mm-font __mm cat">
                        ဟောစာတမ်းဖိုင်အား ၃ ရက်အတွင်း
                        အထက်ပါဖြည့်ထားသောဖုန်းနံပါတ်အားပေးပို့ပေးပါမည်။
                        မိမိသိလိုသော မေးခွန်းအားလုံးကိုရေးပေးပြီး မျက်နှာကို
                        ကြည်လင်ပြတ်သားစွာရိုက်ထားသော ဇာတာရှင်၏
                        ဓာတ်ပုံနှင့်အမည်ကို Viber- 09456880335 (သို့မဟုတ်) 1875
                        Bay Din Messenger သို့ပို့ပေးရန်။
                      </p>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { Horo, HTTP } from "@core/lib/http-common";
import { checkFormModel, getFormData } from "@core/lib/form-data";
import { citizenPay, makePayment, onePay } from "../js/payment";
import { EventBus } from "../../public/js/eventBus";
import { validatePhoneNumber } from "../utils/validationPhone";
import { chooseImageNative, getPlatformInfo } from "../utils/imagePicker";

export default {
  name: `Clairvoyance`,
  data() {
    return {
      datepicker: null,
      actionBtnMethod: "",
      disabled: false,
      onepayPhoneNumber: "",
      clairvoyance: {
        name: "",
        birth_date: "",
        nyih_nan: "",
        phone_number: "",
        order_id: "0",
        gender: "",
        user_id: "0",
        job: "",
        job_detail: "",
        about: "",
        services: ["files"],
        baydin_sayar: "ဆရာမစောဝတီနွယ်",
        marital_status: "",
        price: 10000,
      },
      errors: {},
      isMM: false,
      face_image: null,
      face_image_preview: "",
    };
  },
  mounted() {
    if (this.$refs.datepicker) {
      const input = this.$refs.datepicker.$el.querySelector("input");
      if (input) {
        input.setAttribute("readonly", "true");
      }
    }

    this.actionBtnMethod = this.$store.state.paymentName;
    this.onepayPhoneNumber =
      this.$store.state.paymentName == "onepay"
        ? this.$store.state.onepayPhoneNumber
        : "";

    this.getLocale();
  },
  beforeDestroy() {
    this.resetFormOnUnmount();
  },
  beforeRouteLeave(to, from, next) {
    this.resetFormOnUnmount();
    next();
  },
  deactivated() {
    this.resetFormOnUnmount();
  },
  computed: {
    ...mapGetters({
      getUserToken: "userStore/getUserToken",
      getResponse: "userStore/getResponse",
    }),

    disablePastDates() {
      const today = new Date();
      return (date) => new Date(date) >= today;
    },
  },
  methods: {
    resetFormOnUnmount() {
      try {
        if (this.face_image_preview) URL.revokeObjectURL(this.face_image_preview);
      } catch (e) {
        // Ignore preview cleanup failures.
      }

      this.disabled = false;
      this.errors = {};
      this.onepayPhoneNumber = "";
      this.face_image = null;
      this.face_image_preview = "";

      this.clairvoyance = {
        name: "",
        birth_date: "",
        nyih_nan: "",
        phone_number: "",
        order_id: "0",
        gender: "",
        user_id: "0",
        job: "",
        job_detail: "",
        about: "",
        services: ["files"],
        baydin_sayar: "ဆရာမစောဝတီနွယ်",
        marital_status: "",
        price: 10000,
      };

      this.actionBtnMethod = this.$store.state.paymentName;
      this.onepayPhoneNumber =
        this.$store.state.paymentName == "onepay"
          ? this.$store.state.onepayPhoneNumber
          : "";
    },

    onFaceImageClick() {
      const platform = getPlatformInfo();
      if (platform.isKBZPay && platform.isAndroid) {
        chooseImageNative({ count: 1, sourceType: ["album", "camera"] })
          .then(async (res) => {
            // console.log("Native response:", res);
            // this.$swal("Native response", "success");

            // ALWAYS ensure we have a File object
            let fileObject = null;
            if (res.files && res.files.length > 0) {
              fileObject = res.files[0];
            } else if (res.tempFilePaths && res.tempFilePaths.length > 0) {
              // Conversion failed, try manually
              try {
                this.$swal("IN TRY", "success");
                const xhr = new XMLHttpRequest();
                const blob = await new Promise((resolve, reject) => {
                  xhr.open("GET", res.tempFilePaths[0], true);
                  xhr.responseType = "blob";
                  xhr.onload = () =>
                    xhr.status === 200 || xhr.status === 0
                      ? resolve(xhr.response)
                      : reject();
                  xhr.onerror = reject;
                  xhr.send();
                });
                fileObject = new File([blob], `face_${Date.now()}.jpg`, {
                  type: blob.type || "image/jpeg",
                });
              } catch (err) {
                console.error("All conversion methods failed:", err);
                this.$swal("Error", "ပုံဖတ်ရန် မအောင်မြင်ပါ။", "error");
                return;
              }
            }

            if (!fileObject) {
              this.$swal("Error", "ပုံရွေးချယ်မှု မအောင်မြင်ပါ။", "error");
              return;
            }

            // Set both file and preview from the File object
            this.handleFaceImageFile(fileObject, URL.createObjectURL(fileObject));

            console.log("✓ Image ready:", {
              file: this.face_image,
              preview: this.face_image_preview,
            });
          })
          .catch((err) => {
            console.error("Image selection cancelled or failed:", err);
            this.$swal("Error", "ပုံရွေးချယ်မှု မအောင်မြင်ပါ။ " + (err.message || ""), "error");
          });
      } else {
        // this.$swal("ELSE", "success");
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = "image/*";
        fileInput.style.display = "none";
        document.body.appendChild(fileInput);
        fileInput.onchange = (e) => {
          const file = e.target.files ? e.target.files[0] : null;
          if (file) {
            this.handleFaceImageFile(file, URL.createObjectURL(file));
          }
          document.body.removeChild(fileInput);
        };
        fileInput.onerror = () => {
          document.body.removeChild(fileInput);
        };
        fileInput.click();
      }
    },

    handleFaceImageFile(file, previewUrl) {
      if (!file.type || !file.type.startsWith("image/")) {
        this.errors = {
          ...this.errors,
          face_image: "ပုံဖိုင်ကိုသာ ထည့်ပေးပါရန်လိုအပ်ပါသည်။",
        };
        return;
      }
      if (this.face_image_preview) URL.revokeObjectURL(this.face_image_preview);
      this.face_image = file;
      this.face_image_preview = previewUrl;
      if (this.errors && this.errors.face_image) {
        this.errors = { ...this.errors, face_image: "" };
      }
    },

    onFaceImageChange(event) {
      const file =
        event && event.target && event.target.files
          ? event.target.files[0]
          : null;

      if (!file) return;

      if (!file.type || !file.type.startsWith("image/")) {
        this.errors = {
          ...this.errors,
          face_image: "ပုံဖိုင်ကိုသာ ထည့်ပေးပါရန်လိုအပ်ပါသည်။",
        };
        return;
      }

      this.face_image = file;
      try {
        if (this.face_image_preview) URL.revokeObjectURL(this.face_image_preview);
      } catch (e) {
        // Ignore preview cleanup failures.
      }
      this.face_image_preview = URL.createObjectURL(file);

      if (this.errors && this.errors.face_image) {
        this.errors = { ...this.errors, face_image: "" };
      }
    },

    validateFaceImage() {
      let nextErrors = { ...this.errors };
      let ok = true;
      if (!this.face_image) {
        ok = false;
        nextErrors.face_image = "မျက်နှာပုံ ထည့်ရန်လိုအပ်ပါသည်။";
      }
      this.errors = nextErrors;
      return ok;
    },

    appendFaceImageToFormData(formdata) {
      if (!formdata) return;
      formdata.append("type_of_baydin", "clairvoyance");
      if (this.face_image) formdata.append("face_image", this.face_image);
    },

    getLocale() {
      window.ma.callNativeAPI("getLocale", {}, (res) => {
        this.isMM = res.language === "my-MM";
      });
    },

    paymentProvider() {
      this.validateForm();
      if (Object.values(this.errors).some((v) => v)) return;
      let getPaymentName = this.actionBtnMethod;
      switch (getPaymentName) {
        case "mpitesan":
          this.makePayment();
          break;
        case "onepay":
          this.onePayProvider();
          break;
        case "citizenpay":
          this.citizenPayProvicer();
          break;
        case "bppay":
          this.bpPay();
          break;
        default:
          this.precreate();
          break;
      }
    },

    redirectTNC() {
      this.$router.push("/category/terms_and_conditions");
    },

    async citizenPayProvicer() {
      if (checkFormModel(this.clairvoyance)) {
        if (!this.validateFaceImage()) {
          if (this.isMM) {
            this.$swal("Oops", "မျက်နှာပုံ ထည့်ပေးပါရန်လိုအပ်ပါသည်။", "error");
          } else {
            this.$swal("Oops", "Please upload face image.", "error");
          }
          return;
        }
        this.disabled = true;

        let formdata = getFormData(this.clairvoyance);
        this.appendFaceImageToFormData(formdata);
        formdata.append("user_phone", this.clairvoyance.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: 3477,
          amount: this.clairvoyance.price,
          category_name: "clairvoyance",
        };
        await citizenPay([
          "1875/clairvoyance/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.clairvoyance.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              window.location.href = data.paymentGatway;
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async onePayProvider() {
      if (checkFormModel(this.clairvoyance)) {
        if (!this.validateFaceImage()) {
          if (this.isMM) {
            this.$swal("Oops", "မျက်နှာပုံ ထည့်ပေးပါရန်လိုအပ်ပါသည်။", "error");
          } else {
            this.$swal("Oops", "Please upload face image.", "error");
          }
          return;
        }
        this.disabled = true;

        let formdata = getFormData(this.clairvoyance);
        this.appendFaceImageToFormData(formdata);
        formdata.append("user_phone", this.clairvoyance.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: 3477,
          amount: this.clairvoyance.price,
          category_name: "clairvoyance",
          phone_number:
            this.onepayPhoneNumber == ""
              ? this.clairvoyance.phone_number
              : this.onepayPhoneNumber,
        };
        await onePay([
          "1875/clairvoyance/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.clairvoyance.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async bpPay() {
      if (checkFormModel(this.clairvoyance)) {
        if (!this.validateFaceImage()) {
          if (this.isMM) {
            this.$swal("Oops", "မျက်နှာပုံ ထည့်ပေးပါရန်လိုအပ်ပါသည်။", "error");
          } else {
            this.$swal("Oops", "Please upload face image.", "error");
          }
          return;
        }
        this.disabled = true;

        let formdata = getFormData(this.clairvoyance);
        this.appendFaceImageToFormData(formdata);
        formdata.append("user_phone", this.clairvoyance.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: 3477,
          amount: this.clairvoyance.price,
          category_name: "clairvoyance",
          phone_number: this.clairvoyance.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/clairvoyance/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.clairvoyance.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortalV3",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "PWA BPPay" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },

    async makePayment() {
      if (checkFormModel(this.clairvoyance)) {
        if (!this.validateFaceImage()) {
          if (this.isMM) {
            this.$swal("Oops", "မျက်နှာပုံ ထည့်ပေးပါရန်လိုအပ်ပါသည်။", "error");
          } else {
            this.$swal("Oops", "Please upload face image.", "error");
          }
          return;
        }
        this.disabled = true;

        let formdata = getFormData(this.clairvoyance);
        this.appendFaceImageToFormData(formdata);
        formdata.append("user_phone", this.clairvoyance.phone_number);
        let payment_method =
          this.$store.state.paymentName == " "
            ? "kbz"
            : this.$store.state.paymentName;
        formdata.append("payment_method", payment_method);
        let cdata = {
          category_id: 3477,
          amount: this.clairvoyance.price,
          category_name: "clairvoyance",
          phone_number: this.clairvoyance.phone_number,
          payment_name: this.actionBtnMethod,
        };
        await makePayment([
          "1875/clairvoyance/horoscope",
          formdata,
          cdata,
          this.$store.state.backendUrl,
          this.clairvoyance.price,
        ])
          .then((data) => {
            if (data.status == 200) {
              this.$store.state.order_id = data.order_id;
              this.$store.state.amount = data.amount;
              if (!data.payment_status) {
                this.$router.push({
                  name: "paymentPortal",
                });
              } else {
                this.$router.push({
                  name: "PaymentSuccess",
                  params: { payment: "mpitesan" },
                });
              }
            } else {
              this.$swal("Oops", "Something went wrong!", "error");
            }
          })
          .catch(() => {
            this.$swal("Oops", "Something went wrong!", "error");
          });
      } else {
        this.$swal("Oops", "You need to fill all fields", "error");
      }
    },
    precreate() {
      if (checkFormModel(this.clairvoyance)) {
        if (!this.validateFaceImage()) {
          if (this.isMM) {
            this.$swal("Oops", "မျက်နှာပုံ ထည့်ပေးပါရန်လိုအပ်ပါသည်။", "error");
          } else {
            this.$swal("Oops", "Please upload face image.", "error");
          }
          return;
        }
        this.disabled = true;
        HTTP.defaults.headers.Authorization = `Bearer ${this.getUserToken}`;
        HTTP.post("subscription/precreate", {
          category_id: 3477,
          amount: this.clairvoyance.price,
          category_name: "clairvoyance",
        })
          .then((response) => {
            const res = response.data;
            this.clairvoyance.order_id = res.order_id;
            this.clairvoyance.user_id = res.user_id;
            let formdata = getFormData(this.clairvoyance);
            this.appendFaceImageToFormData(formdata);
            formdata.append(
              "user_phone",
              this.getResponse.customer_info.msisdn,
            );
            formdata.set("price", res.amount);
            Horo.post("1875/clairvoyance/horoscope", formdata).then(
              (response) => {
                this.res_status = response.data.status;

                // new kbzpay mini_app api
                window.ma.callNativeAPI(
                  "startPay",
                  {
                    prepayId: res.prepay_id,
                    orderInfo: res.order_info,
                    sign: res.sign_app,
                    signType: "SHA256",
                    disableNewCheckout: "false",
                    tradeType: "MINIAPP",
                  },
                  (res) => {
                    console.log("startPay api res: ", res);
                    if (res.resultCode == 1) {
                      EventBus.$emit("clear-cache");
                      console.log("startpaysucess");
                      if (!this.isMM) {
                        this.$swal(
                          "Success",
                          "Purchased. Please contact 09456880335 if you have any problems.",
                          "success",
                        );
                        this.$router.push({ name: "home" });
                      }
                      if (this.isMM) {
                        this.$swal(
                          "အောင်မြင်ပါသည်",
                          "ဝယ်ယူပြီးပါပြီ။ အဆင်မပြေမှုများရှိပါက 09456880335 သို့ဆက်သွယ်ပါ။",
                          "success",
                        );
                        this.$router.push({ name: "home" });
                      }
                    } else {
                      if (!this.isMM) {
                        this.$swal("Fail", "Please try again", "error");
                        this.disabled = false;
                      }
                      if (this.isMM) {
                        this.$swal(
                          "မအောင်မြင်ပါ",
                          "ထပ်မံကြိုးစားပေးပါ",
                          "error",
                        );
                        this.disabled = false;
                      }
                    }
                  },
                );

                // this.kbzpay.startPay(
                //   res.prepay_id,
                //   res.order_info,
                //   res.sign_app,
                //   ({ resultCode, lang }) => {
                //     if (resultCode == 1) {
                //       if (lang == "en") {
                //         this.$swal(
                //           "Success",
                //           "Your Purchase Success",
                //           "success"
                //         );
                //         this.$router.push({ name: "home" });
                //       }
                //       if (lang == "my") {
                //         this.$swal(
                //           "အောင်မြင်ပါသည်",
                //           "ဝယ်ယူပြီးပါပြီ",
                //           "success"
                //         );
                //         this.$router.push({ name: "home" });
                //       }
                //     }
                //     if (resultCode == 2) {
                //       if (lang == "en") {
                //         this.$swal("Failed", "Your Purchase Failed", "error");
                //         this.disabled = false;
                //       }
                //       if (lang == "my") {
                //         this.$swal(
                //           "မအောင်မြင်ပါ",
                //           "ထပ်မံကြိုးစားပေးပါ",
                //           "error"
                //         );
                //         this.disabled = false;
                //       }
                //     }
                //   },
                //   () => {
                //     this.$swal("Failed", "Your Purchase Failed", "error");
                //     this.disabled = false;
                //   }
                // );
              },
            );
          })
          .catch((error) => {
            console.log(error);
            this.message = "Something went wrong";
          });
      } else {
        if (this.isMM) {
          this.$swal(
            "Oops",
            "လိုအပ်သည့်အချက်အလက်များ အားလုံးဖြည့်ပေးပါ။",
            "error",
          );
        } else {
          this.$swal("Oops", "You need to fill all fields.", "error");
        }
      }
    },

    validateForm() {
      this.errors = {};

      if (this.clairvoyance.name === "" || !this.clairvoyance.name)
        this.errors.name = "အမည်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.clairvoyance.birth_date === "" || !this.clairvoyance.birth_date)
        this.errors.birth_date = "မွေးသက္ကရာဇ်ထည့်ရန်လိုအပ်ပါသည်။";
      if (this.clairvoyance.nyih_nan === "" || !this.clairvoyance.nyih_nan)
        this.errors.nyih_nan = "နေ့နံရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.clairvoyance.marital_status === "" ||
        !this.clairvoyance.marital_status
      )
        this.errors.marital_status =
          "အိမ်ထောင်ရှိ/မရှိ ရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (
        this.clairvoyance.job === "" ||
        !this.clairvoyance.job ||
        this.clairvoyance.job_detail === "" ||
        !this.clairvoyance.job_detail
      )
        this.errors.job = "အလုပ်အကိုင်အမျိုးအစားရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (this.clairvoyance.gender === "" || !this.clairvoyance.gender)
        this.errors.gender = "ကျား/မ ရွေးချယ်ရန်လိုအပ်ပါသည်။";
      if (!this.clairvoyance.about || this.clairvoyance.about === "")
        this.errors.about = "မေးမြန်းလိုသောအကြောင်းအရာထည့်ရန်လိုအပ်ပါသည်။";
      this.errors.phone_number = validatePhoneNumber(
        this.clairvoyance.phone_number,
      );
      if (!this.face_image) this.errors.face_image = "မျက်နှာပုံ ထည့်ရန်လိုအပ်ပါသည်။";
    },
  },
};
</script>

<style scoped>
input[type="radio"] {
  display: inline;
  margin-top: 8px;
  margin-left: 3px;
}
input[type="checkbox"] {
  display: inline;
  margin-top: 8px;
}

.fixed_sayar_display {
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #f7f7f7;
  color: #222;
}

label {
  display: block;
}

.input-container {
  margin-bottom: 0.5em !important;
}

.md-field.md-theme-default:after {
  background-color: rgba(0, 0, 0, 0);
}
.md-button.md-theme-default {
  margin: 0px 16px 0px 0px;
}

.date__picker {
  margin-top: -8px !important;
  margin-left: 12px !important;
}

.error__phoneNo {
  margin-top: 0.5em !important;
}

.face_upload_title {
  margin-top: 8px;
  margin-bottom: 10px;
}

.face_upload_grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.face_upload_item {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 10px;
  background: #fff;
}

.face_upload_label {
  margin-bottom: 8px;
}

.face_upload_input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  border: 0;
  cursor: pointer;
}

.face_upload_btn {
  position: relative;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  background: #f7f7f7;
  color: #222;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
}

.face_upload_btn:active {
  transform: translateY(1px);
}

.face_upload_preview {
  width: 100%;
  aspect-ratio: 4 / 3;
  height: auto;
  object-fit: cover;
  border-radius: 6px;
  margin-top: 8px;
}

@media (min-width: 420px) {
  .face_upload_preview {
    aspect-ratio: 3 / 2;
  }
}
</style>
